module.exports = __webpack_public_path__ + "img/ganglioncyst_2.4e5eeaaf.gif";